import { map, gte } from '@lendi-ui/breakpoint';
import { mx } from '@lendi-ui/spacing';
import styled, { css } from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var marginX = "1rem";
var xlMaxWidth = '71.25rem';
var responsiveMaxWidth = {
  sm: '33.75rem',
  md: '45rem',
  lg: '60rem',
  xl: xlMaxWidth
};

var _templateObject;
var container = () => css(["box-sizing:border-box;margin:auto ", ";", ";width:calc(100% - ", " * 2);", ";"], marginX, map(responsiveMaxWidth, value => value === undefined ? '' : "width: ".concat(value)), marginX, gte('tablet')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), mx('auto')));
var Container = styled.div.withConfig({
  displayName: "src__Container",
  componentId: "lui__sc-ifo7jj-0"
})(["", ";"], container);

export { container, Container as default };
